import { Box, FormControlLabel, Switch } from '@mui/material';
import { TimeperiodSelect } from 'app/components/ReusableUIComponents/HighLevelComponents/TimePeriodSelectMAIQ';

type Props = {
  timeperiod: Array<{ code: string; name: string }>;
  selectedTimeperiod: string;
  handleClickChangeTimeperiod: (
    code: string,
    label?: string,
    startDate?: string,
    endDate?: string,
  ) => void;
  renderComponent: string;
  disabled: boolean;
  mockApiFlag: boolean;
  handleToggleMockData: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showMockApiToggle: boolean;
};

export default function MetricsFrameworkHeaderControls({
  timeperiod,
  selectedTimeperiod,
  handleClickChangeTimeperiod,
  renderComponent,
  disabled,
  mockApiFlag,
  handleToggleMockData,
  showMockApiToggle,
}: Props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap', flexShrink: 0 }}>
      {showMockApiToggle ? (
        <FormControlLabel
          control={
            <Switch
              checked={mockApiFlag}
              onChange={handleToggleMockData}
              name="useMockData"
              color="primary"
              disabled={disabled}
            />
          }
          label="Use Mock API"
          sx={{ mr: 0, ml: 0 }}
        />
      ) : null}
      <Box
        sx={{
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.6 : 1,
          '& .MuiFormControl-root': {
            width: { xs: '100%', sm: 280 },
            minWidth: { xs: '100%', sm: 200 },
            maxWidth: 280,
          },
        }}
      >
        <TimeperiodSelect
          timeperiod={timeperiod}
          selectedTimeperiod={selectedTimeperiod}
          handleClickChangeTimeperiod={handleClickChangeTimeperiod}
          renderComponent={renderComponent}
        />
      </Box>
    </Box>
  );
}
